import { PROTECTED_URL } from "../../constants"
import axiosPrivate from "@services/axiosPrivate"

export const protectedService = () => {
  return axiosPrivate.get(PROTECTED_URL)
}
